import {Map, fromJS, List} from "immutable";

import {
    GET_YEARS_SUCCESS,
    GET_YEARS_REQUEST,
    GET_YEARS_ERROR,

    CLEAN_YEARS
} from '../actions/years';

const years = (state = Map({
  payload: List([]),
  isFetching: false,
    isUploading: false,
  error: false
}), action) => {
  let newState;
  switch (action.type) {
      // Requests
      case GET_YEARS_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;
      // Success
      case GET_YEARS_SUCCESS:
      case CLEAN_YEARS:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;
      // Errors
      case GET_YEARS_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default years;



// WEBPACK FOOTER //
// ./src/reducers/years.js